import React, {useState, useEffect, useRef, useCallback, memo} from 'react';
import './scss/Feature.scss'
import PropertyThumb from './PropertyThumb'
//icon
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft';

 const FeatureProperty = ({properties}) => {

    const sliderWidth = useRef(null)
    const [listNumber, setListNumber] = useState(4)
    const [currentIndex, setCurrentIndex] = useState(0);
    const [tranlateValue, setTranslateValue] = useState(0)

    console.log('s')
    //useCall back to resize
    const handleResize= useCallback(()=>{
        if(window.innerWidth>1000){
            setListNumber(4)
        }else if(window.innerWidth>600 & window.innerWidth<1000){
            setListNumber(2)
        }else{
            setListNumber(1)
        }
        setCurrentIndex(0)
        setTranslateValue(sliderWidth.current.offsetWidth/listNumber*currentIndex)
    },[currentIndex, listNumber])

    useEffect(()=>{
         //add resize handler
         window.addEventListener("resize", handleResize);
         //checkcurrent window size
         if(window.innerWidth>1000){
            setListNumber(4)
        }else if(window.innerWidth>600 & window.innerWidth<1000){
            setListNumber(2)
        }else{
            setListNumber(1)
        }
        setTranslateValue(sliderWidth.current.offsetWidth/listNumber*currentIndex)

        return ()=>{
            //remove resize handler
           window.removeEventListener("resize", handleResize);
       }
    },[handleResize,currentIndex,listNumber])

     //go to next slide
    function goNext(){
        if(currentIndex>=10-listNumber){
            setCurrentIndex(0);
        }else{
            setCurrentIndex(currentIndex+1);
        }
    }

    //go to prev slide
    function goPrev(){
        if(currentIndex<=0){
            setCurrentIndex(9-4);
        }else{
            setCurrentIndex(currentIndex-1);
        }
    }

    const propertyList = properties.map((property)=>
       <PropertyThumb key={property._id} property={property} />
    )

    return(
        <div className="feature-properties" >
            <div className="wrapper" ref={sliderWidth} style={{transform: `translateX(-${tranlateValue}px)`}}>
                {propertyList}
            </div>
            <div className="arrow arrow-left" onClick={()=>goPrev()} style={{left:0}}>
                <KeyboardArrowLeftIcon />
            </div>
            <div className="arrow arrow-right" onClick={()=>goNext()} style={{right:0}}>
                <KeyboardArrowRightIcon />
            </div>
        </div>
    );
}

export default memo(FeatureProperty)